var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader d-flex flex-column align-center justify-center"},[_c('lottie-vue-player',{staticClass:"loader",staticStyle:{"width":"150px"},attrs:{"src":'/loader.json',"loop":true,"autoplay":true,"backgroundColor":'transparent'}}),_c('span',[_vm._v("powered by Edunix")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }